import { ReportsData, ReportsStatus } from '../reportsViewSlice/types';

export const data: ReportsData = {
  reports: [
    {
      id: '1',
      title: 'חודש מרץ 2025',
      status: ReportsStatus.Pending,
      creation_date: '2025-03-30T00:00:00.000',
      receipts_count: 293,
      sent_to: ['accountant1@gmail.com', 'accountant2@gmail.com'],
      from_date: '2025-03-01T00:00:00.000',
      to_date: '2025-03-31T00:00:00.000',
    },
    {
      id: '2',
      title: 'חודש פברואר 2025',
      status: ReportsStatus.Sent,
      creation_date: '2025-02-28T00:00:00.000',
      receipts_count: 150,
      sent_to: ['accountant1@gmail.com'],
      from_date: '2025-02-01T00:00:00.000',
      to_date: '2025-02-28T00:00:00.000',
    },
  ],
};
